module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "time-show-over",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "opacity": "0.9",
      "background-color": "#444"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "justify-content": "center",
      "position": "fixed",
      "top": "0",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "color": "#fff",
      "margin-bottom": "30px"
    }
  }, [_vm._v("本次训练已结束")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "dialog-btn",
    staticStyle: {
      "border-radius": "40px"
    },
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.close
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "timer"
    }
  }, [_c('mu-circular-progress', {
    staticClass: "timer-modify",
    attrs: {
      "mode": "determinate",
      "size": 120,
      "strokeWidth": 10,
      "value": _vm.timerAll,
      "color": "#ddd"
    }
  }), _vm._v(" "), _c('mu-circular-progress', {
    staticClass: "timer-modify",
    attrs: {
      "mode": "determinate",
      "size": 120,
      "strokeWidth": 10,
      "value": _vm.tmvalue,
      "min": 0,
      "max": _vm.tmMaxValue,
      "color": "#0A81E5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "timer-icon"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("timer")(_vm.oddSecond)))]), _vm._v(" "), (_vm.showPlayType) ? _c('span', {
    on: {
      "click": _vm.timerPause
    }
  }, [_c('mu-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPause),
      expression: "showPause"
    }],
    attrs: {
      "value": "pause",
      "color": "blue",
      "size": 40
    }
  })], 1) : _c('span', {
    on: {
      "click": _vm.timerPlay
    }
  }, [_c('mu-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlay),
      expression: "showPlay"
    }],
    attrs: {
      "value": "play_arrow",
      "color": "blue",
      "size": 40
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a290762!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/timer/Ticker.vue
// module id = 944
// module chunks = 2